import { Loader } from '@grafikr/components';

import getUserRegion from 'utils/get-user-region';
import { NonNullish } from 'utils/nullish-check';

export const HAS_SELECTED_STORAGE_KEY = 'snt:geo:has-chosen-site';

export default Loader(async (_, load) => {
  if (localStorage.getItem(HAS_SELECTED_STORAGE_KEY)) {
    return;
  }

  const url = new URL(window.location.href);
  if (url.searchParams.has('redirected')) {
    localStorage.setItem(HAS_SELECTED_STORAGE_KEY, 'true');
    return;
  }

  if (!document.querySelector('link[rel="alternate"][hreflang]')) {
    // If no links are available, return early
    return;
  }

  const language = NonNullish(navigator.language.split('-').at(0));
  const region = await getUserRegion();

  const selectors = [
    `link[rel="alternate"][hreflang="${language}-${region}"]`,
    `link[rel="alternate"][hreflang$="-${region}"]`,
    `link[rel="alternate"][hreflang^="${language}-"]`,
  ];

  let link: HTMLLinkElement | null = null;
  for (const selector of selectors) {
    link = document.querySelector<HTMLLinkElement>(selector);

    if (link) {
      break;
    }
  }

  if (link) {
    const currentUrl = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.href ?? `${window.location.origin}${window.location.pathname}`;

    if (currentUrl !== link.href) {
      load();
    }
  } else {
    load();
  }
});
